// Panel open/close flex-basis animation duration (bizy-side-panel-dock.tsx).
// Shared so anything that needs to outlive the close animation — e.g.
// delaying an unmount so it doesn't visually shift content underneath it —
// can't drift from the actual transition length.
export const PANEL_OPEN_CLOSE_TRANSITION_MS = 300;

// The route the Bizy intro takeover renders on. Lives here rather than beside the
// flow so the app shell can ask "are we on the takeover?" without importing the
// flow itself (and its cards and gradients) into the initial bundle.
export const BIZY_ONBOARDING_PATH = '/bizy-onboarding';
